
{
  "familyId": "GELD-TERUGREKENEN",
  "questions": [
    {
      "id": "GELD-TERUGREKENEN-001",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een sportwinkel geeft 22% korting op hardloopschoenen. Na korting kosten ze €175,50. Hoeveel kostten de schoenen eerst?",
      "options": ["€270", "€136,89", "€225", "€197,50"],
      "correctAnswer": 2,
      "conceptId": "reverse_discount_22pct",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Telt percentage op als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 22% korting betaal je 78% van de oude prijs (100% − 22% = 78%). Oude prijs = nieuwe prijs ÷ 0,78. Hier: €175,50 ÷ 0,78 = €225.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 22% korting betaal je 78% van de oude prijs (100% − 22% = 78%). Terugrekenen: €175,50 ÷ 0,78 = €225. Check: 22% van €225 = €49,50, en €225 − €49,50 = €175,50 ✓",
        "solutionSteps": [
          "Na 22% korting betaal je 78% van de oude prijs (100% − 22% = 78%)",
          "Oude prijs = €175,50 ÷ 0,78",
          "€175,50 ÷ 0,78 = €225",
          "Check: 22% van €225 = €49,50, €225 − €49,50 = €175,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt gedeeld door een verkeerd percentage (bijv. 0,65). Bij 22% korting betaal je 78%. Reken terug: €175,50 ÷ 0,78 = €225.",
          "1": "Je hebt de korting er nog een keer afgehaald. €175,50 is al de prijs ná korting. Reken terug: €175,50 ÷ 0,78 = €225.",
          "2": "Goed! €175,50 is 78% van de oude prijs. €175,50 ÷ 0,78 = €225.",
          "3": "Je hebt er €22 bij opgeteld. Maar 22% is niet hetzelfde als €22. Reken met percentages: €175,50 ÷ 0,78 = €225."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-002",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker verhoogt de prijs van een reparatie met 13%. De nieuwe prijs is €248,60. Wat was de oude prijs?",
      "options": ["€210", "€220", "€280,92", "€235,60"],
      "correctAnswer": 1,
      "conceptId": "reverse_increase_13pct",
      "variantIndex": 2,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 0 },
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 2 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 13% verhoging is de prijs 113% van het origineel (100% + 13% = 113%). Oude prijs = nieuwe prijs ÷ 1,13. Hier: €248,60 ÷ 1,13 = €220.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 13% verhoging is de prijs 113% van de oude prijs. Terugrekenen: €248,60 ÷ 1,13 = €220. Check: 13% van €220 = €28,60, €220 + €28,60 = €248,60 ✓",
        "solutionSteps": [
          "Na 13% verhoging betaal je 113% van de oude prijs",
          "Oude prijs = €248,60 ÷ 1,13",
          "€248,60 ÷ 1,13 = €220",
          "Check: 13% van €220 = €28,60, €220 + €28,60 = €248,60 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 13% van de NIEUWE prijs afgetrokken en afgerond. Maar de verhoging was 13% van de OUDE prijs. Deel door 1,13: €248,60 ÷ 1,13 = €220.",
          "1": "Goed! €248,60 is 113% van de oude prijs. €248,60 ÷ 1,13 = €220.",
          "2": "Je hebt de nieuwe prijs nóg een keer met 13% verhoogd. Je moet juist terug: €248,60 ÷ 1,13 = €220.",
          "3": "Je hebt er €13 afgehaald. Maar 13% is niet altijd €13 — het hangt af van het bedrag. €248,60 ÷ 1,13 = €220."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-003",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Bij een speelgoedwinkel is een skateboard 28% afgeprijsd. Je betaalt nu €126. Reken terug: wat was de oude prijs?",
      "options": ["€210", "€90,72", "€157,50", "€175"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_28pct",
      "variantIndex": 3,
      "citoDifficulty": 0.57,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage (0,60 i.p.v. 0,72)", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 28% korting",
            "content": "Na 28% korting betaal je 72% van de oude prijs. Oude prijs = €126 ÷ 0,72 = €175.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 28% korting betaal je 72% van de oude prijs (100% − 28% = 72%). Terugrekenen: €126 ÷ 0,72 = €175. Check: 28% van €175 = €49, €175 − €49 = €126 ✓",
        "solutionSteps": [
          "Na 28% korting betaal je 72% van de oude prijs",
          "Oude prijs = €126 ÷ 0,72",
          "€126 ÷ 0,72 = €175",
          "Check: 28% van €175 = €49, €175 − €49 = €126 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt gedeeld door 0,60 in plaats van 0,72. Bij 28% korting betaal je 72%. Deel door 0,72: €126 ÷ 0,72 = €175.",
          "1": "Je hebt de korting er nog een keer afgehaald. €126 is al de prijs ná korting. Deel door 0,72: €126 ÷ 0,72 = €175.",
          "2": "Je hebt gedeeld door 0,80 in plaats van 0,72. Bij 28% korting betaal je 72%, niet 80%. Deel door 0,72: €126 ÷ 0,72 = €175.",
          "3": "Goed! €126 is 72% van de oude prijs. Terugrekenen: €126 ÷ 0,72 = €175."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-004",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een boekwinkel geeft 18% korting. Een boek kost nu €241,90. Wat was de prijs vóór de korting?",
      "correctAnswer": "295",
      "data": {
        "acceptedAnswers": ["295", "€295", "295,00", "€295,00", "295.00"],
        "placeholder": "oude prijs in €",
        "inputType": "number"
      },
      "conceptId": "reverse_discount_18pct",
      "variantIndex": 4,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 18% korting",
            "content": "Na 18% korting betaal je 82% van de oude prijs. Oude prijs = €241,90 ÷ 0,82 = €295.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 18% korting betaal je 82% van de oude prijs. Terugrekenen: €241,90 ÷ 0,82 = €295. Check: 18% van €295 = €53,10, €295 − €53,10 = €241,90 ✓",
        "solutionSteps": [
          "Na 18% korting betaal je 82% van de oude prijs",
          "Oude prijs = €241,90 ÷ 0,82",
          "€241,90 ÷ 0,82 = €295",
          "Check: 18% van €295 = €53,10, €295 − €53,10 = €241,90 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-005",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een kledingwinkel verhoogt de prijs van een winterjas met 22%. De jas kost nu €225,70. Wat betaalde je eerst?",
      "options": ["€275,35", "€170", "€185", "€203,70"],
      "correctAnswer": 2,
      "conceptId": "reverse_increase_22pct",
      "variantIndex": 5,
      "citoDifficulty": 0.57,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 1 },
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 0 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 22% verhoging",
            "content": "Na 22% verhoging is de prijs 122% van het origineel. Werk via 1%: 122% = €225,70, dus 1% = €225,70 ÷ 122 = €1,85 en 100% = €185. (Sneller kan ook: €225,70 ÷ 1,22 = €185.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 22% verhoging is de prijs 122% van de oude prijs. Terugrekenen: €225,70 ÷ 1,22 = €185. Check: 22% van €185 = €40,70, €185 + €40,70 = €225,70 ✓",
        "solutionSteps": [
          "122% = €225,70",
          "1% = €225,70 ÷ 122 = €1,85",
          "100% = €1,85 × 100 = €185",
          "Check: 22% van €185 = €40,70, €185 + €40,70 = €225,70 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de nieuwe prijs nóg een keer met 22% verhoogd. Je moet juist terug: €225,70 ÷ 1,22 = €185.",
          "1": "Je hebt 22% van €225,70 afgetrokken en afgerond. Maar de verhoging was 22% van de OUDE prijs. Deel door 1,22.",
          "2": "Goed! Na 22% verhoging is €225,70 = 122% van de oude prijs. €225,70 ÷ 1,22 = €185.",
          "3": "Je hebt er €22 afgehaald. Maar 22% is niet hetzelfde als €22. Reken met percentages: €225,70 ÷ 1,22 = €185."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-006",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een dierenarts verhoogt de prijs van een behandeling met 32%. Je betaalt nu €59,40. Hoeveel kostte de behandeling eerst?",
      "options": ["€78,41", "€45", "€40", "€27,40"],
      "correctAnswer": 1,
      "conceptId": "reverse_increase_32pct",
      "variantIndex": 6,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 2 },
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 0 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Gokt op veel te laag bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 32% verhoging",
            "content": "Na 32% verhoging is de prijs 132% van het origineel. Werk via 1%: 132% = €59,40, dus 1% = €59,40 ÷ 132 = €0,45 en 100% = €45. (Sneller kan ook: €59,40 ÷ 1,32 = €45.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 32% verhoging is de prijs 132% van de oude prijs. Terugrekenen: €59,40 ÷ 1,32 = €45. Check: 32% van €45 = €14,40, €45 + €14,40 = €59,40 ✓",
        "solutionSteps": [
          "132% = €59,40",
          "1% = €59,40 ÷ 132 = €0,45",
          "100% = €45",
          "Check: 32% van €45 = €14,40, €45 + €14,40 = €59,40 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de nieuwe prijs nóg een keer met 32% verhoogd. Je moet juist terug: €59,40 ÷ 1,32 = €45.",
          "1": "Goed! Na 32% verhoging is €59,40 = 132% van de oude prijs. €59,40 ÷ 1,32 = €45.",
          "2": "Je hebt 32% van de nieuwe prijs afgetrokken en afgerond. Maar de verhoging was 32% van de OUDE prijs. Deel door 1,32.",
          "3": "Dit bedrag is veel te laag. Onthoud: de oude prijs is lager dan de verhoogde prijs, maar niet zó laag."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-007",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "In de uitverkoop bij een elektronicawinkel is een tablet 28% goedkoper. Je betaalt €198. Wat was de oude prijs van de tablet?",
      "options": ["€330", "€142,56", "€247,50", "€275"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_28pct_b",
      "variantIndex": 7,
      "citoDifficulty": 0.57,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage (0,60 i.p.v. 0,72)", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 28% korting",
            "content": "Na 28% korting betaal je 72% van de oude prijs. Werk via 1%: 72% = €198, dus 1% = €198 ÷ 72 = €2,75 en 100% = €275. (Sneller kan ook: €198 ÷ 0,72 = €275.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 28% korting betaal je nog 72% van de oude prijs (100% − 28% = 72%). Terugrekenen: €198 ÷ 0,72 = €275. Check: 28% van €275 = €77, €275 − €77 = €198 ✓",
        "solutionSteps": [
          "72% = €198",
          "1% = €198 ÷ 72 = €2,75",
          "100% = €275",
          "Check: 28% van €275 = €77, €275 − €77 = €198 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt gedeeld door 0,60 in plaats van 0,72. Bij 28% korting betaal je 72%. Deel door 0,72: €198 ÷ 0,72 = €275.",
          "1": "Je hebt de korting er nog een keer afgehaald. €198 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,80 in plaats van 0,72. Bij 28% korting betaal je 72%, niet 80%. Deel door 0,72: €198 ÷ 0,72 = €275.",
          "3": "Goed! Na 28% korting betaal je 72% van de oude prijs. €198 ÷ 0,72 = €275."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-008",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een muziekwinkel geeft 22% korting op een gitaar. De gitaar kost nu €82,68. Bereken de prijs vóór de korting.",
      "correctAnswer": "106",
      "data": {
        "acceptedAnswers": ["106", "€106", "106,00", "€106,00", "106.00"],
        "placeholder": "oude prijs in €",
        "inputType": "number"
      },
      "conceptId": "reverse_discount_22pct_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 22% korting",
            "content": "Na 22% korting betaal je 78% van de oude prijs. Oude prijs = €82,68 ÷ 0,78 = €106.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 22% korting betaal je 78% van de oude prijs. Terugrekenen: €82,68 ÷ 0,78 = €106. Check: 22% van €106 = €23,32, €106 − €23,32 = €82,68 ✓",
        "solutionSteps": [
          "Na 22% korting betaal je 78% van de oude prijs",
          "Oude prijs = €82,68 ÷ 0,78",
          "€82,68 ÷ 0,78 = €106",
          "Check: 22% van €106 = €23,32, €106 − €23,32 = €82,68 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-009",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een schoenenwinkelier prijst sneakers 24% af. Ze kosten nu €486,40. Hoeveel kostten ze vóór de actie?",
      "options": ["€379,39", "€640", "€600", "€694,86"],
      "correctAnswer": 1,
      "conceptId": "reverse_discount_24pct_large",
      "variantIndex": 9,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 2 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 0 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 24% korting",
            "content": "Na 24% korting betaal je 76% van de oude prijs. Werk via 1%: 76% = €486,40, dus 1% = €486,40 ÷ 76 = €6,40 en 100% = €640. (Sneller kan ook: €486,40 ÷ 0,76 = €640.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 24% korting betaal je 76% van de oude prijs. Terugrekenen: €486,40 ÷ 0,76 = €640. Check: 24% van €640 = €153,60, €640 − €153,60 = €486,40 ✓",
        "solutionSteps": [
          "76% = €486,40",
          "1% = €486,40 ÷ 76 = €6,40",
          "100% = €640",
          "Check: 24% van €640 = €153,60, €640 − €153,60 = €486,40 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de korting er nog een keer afgehaald. €486,40 is al de prijs ná korting.",
          "1": "Goed! Na 24% korting betaal je 76% van de oude prijs. €486,40 ÷ 0,76 = €640.",
          "2": "Je hebt 24% van €486,40 erbij opgeteld en afgerond. Maar de korting was 24% van de OUDE prijs.",
          "3": "Je hebt gedeeld door 0,70 in plaats van 0,76. Bij 24% korting betaal je 76%, niet 70%. Deel door 0,76: €486,40 ÷ 0,76 = €640."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-010",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een zwemschool verhoogt het lesgeld met 13%. Het nieuwe bedrag is €203,40. Wat was het oude lesgeld?",
      "correctAnswer": "180",
      "data": {
        "acceptedAnswers": ["180", "€180", "180,00", "€180,00", "180.00"],
        "placeholder": "oud bedrag in €",
        "inputType": "number"
      },
      "conceptId": "reverse_increase_13pct_large",
      "variantIndex": 10,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 13% verhoging",
            "content": "Na 13% verhoging is de prijs 113% van het origineel. Oude prijs = €203,40 ÷ 1,13 = €180.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 13% verhoging is de prijs 113% van de oude prijs. Terugrekenen: €203,40 ÷ 1,13 = €180. Check: 13% van €180 = €23,40, €180 + €23,40 = €203,40 ✓",
        "solutionSteps": [
          "Na 13% verhoging betaal je 113% van de oude prijs",
          "Oude prijs = €203,40 ÷ 1,13",
          "€203,40 ÷ 1,13 = €180",
          "Check: 13% van €180 = €23,40, €180 + €23,40 = €203,40 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-011",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Tijdens de opruiming bij een meubelzaak krijg je 38% korting. Je betaalt €130,20 voor een bureaustoel. Wat was de oude prijs?",
      "options": ["€250", "€80,72", "€186", "€210"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_38pct",
      "variantIndex": 11,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage (0,50 i.p.v. 0,62)", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 38% korting",
            "content": "Na 38% korting betaal je 62% van de oude prijs. Werk via 1%: 62% = €130,20, dus 1% = €130,20 ÷ 62 = €2,10 en 100% = €210. (Sneller kan ook: €130,20 ÷ 0,62 = €210.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 38% korting betaal je nog 62% van de oude prijs. Terugrekenen: €130,20 ÷ 0,62 = €210. Check: 38% van €210 = €79,80, €210 − €79,80 = €130,20 ✓",
        "solutionSteps": [
          "62% = €130,20",
          "1% = €130,20 ÷ 62 = €2,10",
          "100% = €210",
          "Check: 38% van €210 = €79,80, €210 − €79,80 = €130,20 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt gedeeld door een verkeerd percentage. Bij 38% korting betaal je 62%. Deel door 0,62: €130,20 ÷ 0,62 = €210.",
          "1": "Je hebt de korting er nog een keer afgehaald. €130,20 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,70 in plaats van 0,62. Bij 38% korting betaal je 62%, niet 70%. Deel door 0,62: €130,20 ÷ 0,62 = €210.",
          "3": "Goed! Na 38% korting betaal je 62% van de oude prijs. €130,20 ÷ 0,62 = €210."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-012",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een bakker verhoogt de prijs van een taart met 44%. De taart kost nu €133,92. Hoeveel kostte de taart eerst?",
      "options": ["€93", "€192,84", "€75", "€89,92"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_44pct",
      "variantIndex": 12,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 1 },
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 2 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 44% verhoging",
            "content": "Na 44% verhoging is de prijs 144% van het origineel. Oude prijs = €133,92 ÷ 1,44 = €93.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 44% verhoging is de prijs 144% van de oude prijs. Terugrekenen: €133,92 ÷ 1,44 = €93. Check: 44% van €93 = €40,92, €93 + €40,92 = €133,92 ✓",
        "solutionSteps": [
          "144% = €133,92",
          "1% = €133,92 ÷ 144 = €0,93",
          "100% = €93",
          "Check: 44% van €93 = €40,92, €93 + €40,92 = €133,92 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Na 44% verhoging is €133,92 = 144% van de oude prijs. €133,92 ÷ 1,44 = €93.",
          "1": "Je hebt de nieuwe prijs nóg een keer met 44% verhoogd. Je moet juist terug: €133,92 ÷ 1,44 = €93.",
          "2": "Je hebt 44% van de nieuwe prijs afgetrokken en afgerond. Maar de verhoging was 44% van de OUDE prijs. Deel door 1,44.",
          "3": "Je hebt er €44 afgehaald. Maar 44% is niet hetzelfde als €44. Reken met percentages."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-013",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een smartwatch is met 13% afgeprijsd bij een elektronicawinkel. Je betaalt nu €237,51. Reken terug naar de oude prijs.",
      "options": ["€260", "€206,63", "€296,89", "€273"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_13pct",
      "variantIndex": 13,
      "citoDifficulty": 0.59,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 13% korting",
            "content": "Na 13% korting betaal je 87% van de oude prijs. Werk via 1%: 87% = €237,51, dus 1% = €237,51 ÷ 87 = €2,73 en 100% = €273. (Sneller kan ook: €237,51 ÷ 0,87 = €273.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 13% korting betaal je 87% van de oude prijs. Terugrekenen: €237,51 ÷ 0,87 = €273. Check: 13% van €273 = €35,49, €273 − €35,49 = €237,51 ✓",
        "solutionSteps": [
          "87% = €237,51",
          "1% = €237,51 ÷ 87 = €2,73",
          "100% = €273",
          "Check: 13% van €273 = €35,49, €273 − €35,49 = €237,51 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 13% van de nieuwe prijs erbij opgeteld en afgerond. Maar de korting was 13% van de OUDE prijs. Deel door 0,87.",
          "1": "Je hebt de korting er nog een keer afgehaald. €237,51 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,80 in plaats van 0,87. Bij 13% korting betaal je 87%, niet 80%. Deel door 0,87: €237,51 ÷ 0,87 = €273.",
          "3": "Goed! Na 13% korting betaal je 87% van de oude prijs. €237,51 ÷ 0,87 = €273."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-014",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een tuincentrum verhoogt de prijs van een barbecue met 17%. De barbecue kost nu €269,10. Wat was de oude prijs?",
      "options": ["€314,85", "€230", "€220", "€252,10"],
      "correctAnswer": 1,
      "conceptId": "reverse_increase_17pct",
      "variantIndex": 14,
      "citoDifficulty": 0.59,
      "citoDiscrimination": 0.65,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 0 },
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 2 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 17% verhoging",
            "content": "Na 17% verhoging is de prijs 117% van het origineel. Werk via 1%: 117% = €269,10, dus 1% = €269,10 ÷ 117 = €2,30 en 100% = €230. (Sneller kan ook: €269,10 ÷ 1,17 = €230.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 17% verhoging is de prijs 117% van de oude prijs. Terugrekenen: €269,10 ÷ 1,17 = €230. Check: 17% van €230 = €39,10, €230 + €39,10 = €269,10 ✓",
        "solutionSteps": [
          "117% = €269,10",
          "1% = €269,10 ÷ 117 = €2,30",
          "100% = €230",
          "Check: 17% van €230 = €39,10, €230 + €39,10 = €269,10 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de nieuwe prijs nóg een keer met 17% verhoogd. Je moet juist terug: €269,10 ÷ 1,17 = €230.",
          "1": "Goed! Na 17% verhoging is €269,10 = 117% van de oude prijs. €269,10 ÷ 1,17 = €230.",
          "2": "Je hebt 17% van de nieuwe prijs afgetrokken en afgerond. Maar de verhoging was 17% van de OUDE prijs. Deel door 1,17.",
          "3": "Je hebt er €17 afgehaald. Maar 17% van €230 = €39,10, niet €17."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-015",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een televisie is bij een actie 23% goedkoper geworden. Je betaalt nu €331,10. Hoeveel kostte de televisie vóór de actie?",
      "options": ["€400", "€254,95", "€473", "€430"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_23pct",
      "variantIndex": 15,
      "citoDifficulty": 0.59,
      "citoDiscrimination": 0.64,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs en rondt af", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 23% korting",
            "content": "Na 23% korting betaal je 77% van de oude prijs. Werk via 1%: 77% = €331,10, dus 1% = €331,10 ÷ 77 = €4,30 en 100% = €430. (Sneller kan ook: €331,10 ÷ 0,77 = €430.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 23% korting betaal je 77% van de oude prijs (100% − 23% = 77%). Terugrekenen: €331,10 ÷ 0,77 = €430. Check: 23% van €430 = €98,90, €430 − €98,90 = €331,10 ✓",
        "solutionSteps": [
          "77% = €331,10",
          "1% = €331,10 ÷ 77 = €4,30",
          "100% = €430",
          "Check: 23% van €430 = €98,90, €430 − €98,90 = €331,10 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 23% van €331,10 erbij opgeteld en afgerond. Maar de korting was 23% van de OUDE prijs. Deel door 0,77.",
          "1": "Je hebt de korting er nog een keer afgehaald. €331,10 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,70 in plaats van 0,77. Bij 23% korting betaal je 77%, niet 70%. Deel door 0,77: €331,10 ÷ 0,77 = €430.",
          "3": "Goed! Na 23% korting betaal je 77% van de oude prijs. €331,10 ÷ 0,77 = €430."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-016",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een campingwinkel geeft 38% korting op een tent. De tent kost nu €133,30. Bereken de oorspronkelijke prijs.",
      "options": ["€215", "€250", "€82,65", "€190,43"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_38pct_b",
      "variantIndex": 16,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.64,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage (0,50 i.p.v. 0,62)", "optionIndex": 1 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 2 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 38% korting",
            "content": "Na 38% korting betaal je 62% van de oude prijs. Werk via 1%: 62% = €133,30, dus 1% = €133,30 ÷ 62 = €2,15 en 100% = €215. (Sneller kan ook: €133,30 ÷ 0,62 = €215.)",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 38% korting betaal je 62% van de oude prijs (100% − 38% = 62%). Terugrekenen: €133,30 ÷ 0,62 = €215. Check: 38% van €215 = €81,70, €215 − €81,70 = €133,30 ✓",
        "solutionSteps": [
          "62% = €133,30",
          "1% = €133,30 ÷ 62 = €2,15",
          "100% = €215",
          "Check: 38% van €215 = €81,70, €215 − €81,70 = €133,30 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Na 38% korting betaal je 62% van de oude prijs. €133,30 ÷ 0,62 = €215.",
          "1": "Je hebt gedeeld door een verkeerd percentage. Bij 38% korting betaal je 62%. Deel door 0,62: €133,30 ÷ 0,62 = €215.",
          "2": "Je hebt de korting er nog een keer afgehaald. €133,30 is al de prijs ná korting.",
          "3": "Je hebt gedeeld door 0,70 in plaats van 0,62. Bij 38% korting betaal je 62%, niet 70%. Deel door 0,62: €133,30 ÷ 0,62 = €215."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-017",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een kledingwinkel geeft 22% korting op een trui. De trui kost nu €85,80. Wat was de oude prijs?",
      "correctAnswer": "110",
      "data": {
        "acceptedAnswers": ["110", "€110", "110,00", "€110,00", "110.00"],
        "placeholder": "oude prijs in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 22% korting betaal je 78% van de oude prijs (100% − 22% = 78%). 78% = €85,80, dus 1% = €1,10 en 100% = €110.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "reverse_discount_22pct_fill_in",
      "variantIndex": 17,
      "citoDifficulty": 0.57,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Na 22% korting betaal je 78% van de oude prijs. 78% = €85,80, dus 1% = €1,10 en 100% = €110. Check: 22% van €110 = €24,20, €110 − €24,20 = €85,80 ✓",
        "solutionSteps": [
          "Na 22% korting betaal je 78% van de oude prijs",
          "78% = €85,80",
          "1% = €85,80 ÷ 78 = €1,10",
          "100% = €1,10 × 100 = €110",
          "Check: 22% van €110 = €24,20, €110 − €24,20 = €85,80 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-018",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een sportschool verhoogt het abonnement met 17%. Het nieuwe bedrag is €91,26. Wat was het oude bedrag?",
      "correctAnswer": "78",
      "data": {
        "acceptedAnswers": ["78", "€78", "78,00", "€78,00", "78.00"],
        "placeholder": "oud bedrag in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 17% verhoging is de prijs 117% van het origineel. Oude prijs = €91,26 ÷ 1,17 = €78.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "reverse_increase_17pct_fill_in",
      "variantIndex": 18,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Na 17% verhoging is de prijs 117% van de oude prijs. Terugrekenen: €91,26 ÷ 1,17 = €78. Check: 17% van €78 = €13,26, €78 + €13,26 = €91,26 ✓",
        "solutionSteps": [
          "Na 17% verhoging betaal je 117% van de oude prijs",
          "Oude prijs = €91,26 ÷ 1,17",
          "€91,26 ÷ 1,17 = €78",
          "Check: 17% van €78 = €13,26, €78 + €13,26 = €91,26 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-019",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "ordering",
      "question": "Een fiets kost na 27% korting €197,10 bij de fietsenmaker. Zet de stappen om de oude prijs te berekenen in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Bepaal welk percentage de kortingsprijs is: 100% − 27% = 73%",
          "Schrijf de vergelijking op: 73% = €197,10",
          "Bereken 1%: €197,10 ÷ 73 = €2,70",
          "Bereken 100%: €2,70 × 100 = €270",
          "Check: 27% van €270 = €72,90. €270 − €72,90 = €197,10 ✓"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "conceptId": "reverse_discount_ordering_steps_27pct",
      "variantIndex": 19,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.65,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen",
            "content": "Bij terugrekenen werk je altijd in deze volgorde: 1) Bepaal het percentage van de nieuwe prijs, 2) Stel de vergelijking op, 3) Bereken 1%, 4) Bereken 100%, 5) Check je antwoord.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij terugrekenen volg je een vast stappenplan. Eerst bepaal je dat de kortingsprijs 73% is (100% − 27%). Dan stel je op: 73% = €197,10. Vervolgens bereken je 1%: €197,10 ÷ 73 = €2,70. Dan 100%: €2,70 × 100 = €270. Tot slot check je: 27% van €270 = €72,90, en €270 − €72,90 = €197,10 ✓.",
        "solutionSteps": [
          "73% = €197,10 (de kortingsprijs)",
          "1% = €197,10 ÷ 73 = €2,70",
          "100% = €2,70 × 100 = €270",
          "Check: 27% van €270 = €72,90, €270 − €72,90 = €197,10 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-020",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "step_solver",
      "question": "Een buurtbus heeft de prijs van een kaartje met 17% verhoogd. Een kaartje kost nu €5,85. Reken stap voor stap terug naar de oude prijs.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Welk percentage van de oude prijs is €5,85? (100% + 17% = ...%)",
              "correctAnswer": "117",
              "acceptedAnswers": ["117", "117%", "117 %", "117 procent"],
              "hint": "Bij een verhoging tel je het percentage op bij 100%."
            },
            {
              "prompt": "Hoeveel is 1%? (€5,85 ÷ 117 = ... euro)",
              "correctAnswer": "0,05",
              "acceptedAnswers": ["0,05", "0.05", "€0,05", "5 cent"],
              "hint": "Deel de nieuwe prijs door het totale percentage uit stap 1."
            },
            {
              "prompt": "Wat was de oude prijs in euro? (100% = 1% × 100)",
              "correctAnswer": "5",
              "acceptedAnswers": ["5", "€5", "5,00", "€5,00"],
              "hint": "Vermenigvuldig 1% met 100 om de oorspronkelijke prijs te krijgen."
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "reverse_increase_step_solver_17pct",
      "variantIndex": 20,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "geld.subtract-instead-of-add", "label": "Trekt verhoging af i.p.v. op te tellen bij 100%" },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Behandelt het verhogingspercentage als vast bedrag" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen bij verhoging",
            "content": "Stap 1: Bepaal het totale percentage (100% + verhogings%). Stap 2: Bereken 1% door de nieuwe prijs te delen door dat percentage. Stap 3: Bereken 100% door 1% met 100 te vermenigvuldigen. Controleer altijd: oude prijs × (1 + verhogings%/100) = nieuwe prijs.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij 17% verhoging is €5,85 gelijk aan 117% van de oude prijs. Stap 1: 117%. Stap 2: 1% = €5,85 ÷ 117 = €0,05. Stap 3: 100% = €0,05 × 100 = €5. Controleer: €5 × 1,17 = €5,85 ✓.",
        "solutionSteps": [
          "117% = €5,85 (de nieuwe, verhoogde prijs)",
          "1% = €5,85 ÷ 117 = €0,05",
          "100% = €0,05 × 100 = €5 (de oude prijs)",
          "Controle: €5 × 1,17 = €5,85 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-021",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "step_solver",
      "question": "Een koptelefoon kost na 22% korting €117 bij een elektronicawinkel. Reken stap voor stap terug naar de oude prijs.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Welk percentage van de oude prijs is €117? (100% − 22% = ...%)",
              "correctAnswer": "78",
              "acceptedAnswers": ["78", "78%", "78 %", "78 procent"],
              "hint": "Trek het kortingspercentage af van 100%"
            },
            {
              "prompt": "Hoeveel is 1%? (€117 ÷ 78 = ...)",
              "correctAnswer": "1,50",
              "acceptedAnswers": ["1,50", "1.50", "€1,50", "1,5", "1.5"],
              "hint": "Deel de kortingsprijs door het percentage"
            },
            {
              "prompt": "Wat is 100%? (de oude prijs in €)",
              "correctAnswer": "150",
              "acceptedAnswers": ["150", "€150", "150,00", "€150,00"],
              "hint": "Vermenigvuldig 1% met 100"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "reverse_discount_step_solver_22pct",
      "variantIndex": 21,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.66,
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "geld.add-instead-of-subtract", "label": "Telt korting op bij 100% i.p.v. aftrekken" },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Behandelt het kortingspercentage als vast bedrag" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen",
            "content": "Stap 1: Bepaal het percentage (100% − korting%). Stap 2: Bereken 1% (prijs ÷ percentage). Stap 3: Bereken 100% (1% × 100). Hier: 78% = €117, 1% = €1,50, 100% = €150.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 22% korting is de prijs 78% van het origineel. Stap 1: 78% = €117. Stap 2: 1% = €117 ÷ 78 = €1,50. Stap 3: 100% = €1,50 × 100 = €150. Check: 22% van €150 = €33, €150 − €33 = €117 ✓",
        "solutionSteps": [
          "78% = €117 (de kortingsprijs)",
          "1% = €117 ÷ 78 = €1,50",
          "100% = €1,50 × 100 = €150",
          "Check: 22% van €150 = €33, €150 − €33 = €117 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-022",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "step_solver",
      "question": "Een hotelkamer is met 17% duurder geworden. De nieuwe prijs is €234. Reken stap voor stap terug naar de oude prijs.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Welk percentage van de oude prijs is €234? (100% + 17% = ...%)",
              "correctAnswer": "117",
              "acceptedAnswers": ["117", "117%", "117 %", "117 procent"],
              "hint": "Tel het verhogingspercentage op bij 100%"
            },
            {
              "prompt": "Hoeveel is 1%? (€234 ÷ 117 = ...)",
              "correctAnswer": "2",
              "acceptedAnswers": ["2", "€2", "2,00", "€2,00", "2.00"],
              "hint": "Deel de nieuwe prijs door het percentage"
            },
            {
              "prompt": "Wat is 100%? (de oude prijs in €)",
              "correctAnswer": "200",
              "acceptedAnswers": ["200", "€200", "200,00", "€200,00"],
              "hint": "Vermenigvuldig 1% met 100"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "reverse_increase_step_solver_17pct",
      "variantIndex": 22,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.67,
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "geld.subtract-instead-of-add", "label": "Trekt verhoging af i.p.v. op te tellen bij 100%" },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Behandelt het verhogingspercentage als vast bedrag" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen bij verhoging",
            "content": "Stap 1: Bepaal het percentage (100% + verhoging%). Stap 2: Bereken 1% (prijs ÷ percentage). Stap 3: Bereken 100% (1% × 100). Hier: 117% = €234, 1% = €2, 100% = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 17% verhoging is de prijs 117% van het origineel. Stap 1: 117% = €234. Stap 2: 1% = €234 ÷ 117 = €2. Stap 3: 100% = €2 × 100 = €200. Check: 17% van €200 = €34, €200 + €34 = €234 ✓",
        "solutionSteps": [
          "117% = €234 (de verhoogde prijs)",
          "1% = €234 ÷ 117 = €2",
          "100% = €2 × 100 = €200",
          "Check: 17% van €200 = €34, €200 + €34 = €234 ✓"
        ]
      }
    }
  ]
}
